/**
 * 设备枚举
 */
export const enum DeviceEnum {
  /**
   * 宽屏设备
   */
  DESKTOP = "desktop",

  /**
   * 窄屏设备
   */
  MOBILE = "mobile",
}
